import Loader from "@/components/loader/Loader.vue";
import {EventsTypes} from "@/enums/EventsTypes";
import moment from "moment/moment";
import {EventsTypesMinor} from "@/enums/EventsTypesMinor";
import imageToBase64 from 'image-to-base64/browser';
import {CalendarTypeEnum} from "@/enums/CalendarTypeEnum";
import {CalendarFormatWeek} from "@/enums/CalendarFormatWeek";
import {PrintableCalendarFonts} from "@/consts/PrintableCalendarFonts";
import {PrintableCalendarFontSizes} from "@/consts/PrintableCalendarFontSizes";
import html2canvas from "html2canvas";
import {EventLocations} from "@/enums/EventLocations";
import {getRegionEnv} from "@/utils/functionsRegionEnv";
import {CalendarStyles} from "@/enums/CalendarStyles";
import PrintableCalendarHeader
  from "@/views/calender/printable-calendar-components/printable-calendar-header/PrintableCalendarHeader.vue";
import VueHtml2pdf from 'vue-html2pdf';
import PrintableCalendarToolbar
  from "@/views/calender/printable-calendar-components/printable-calendar-toolbar/PrintableCalendarToolbar.vue";
import PrintableCalendarPagination
  from "@/views/calender/printable-calendar-components/printable-calendar-pagination/PrintableCalendarPagination.vue";
import PrintableCalendarPdf
  from "@/views/calender/printable-calendar-components/printable-calendar-pdf/PrintableCalendarPdf.vue";
import PrintableCalendarListHeader
  from "@/views/calender/printable-calendar-components/printable-calendar-list-header/PrintableCalendarListHeader.vue";
import PrintableCalendarSettings
  from "@/views/calender/printable-calendar-components/printable-calendar-settings/PrintableCalendarSettings.vue";
import { formatUrl } from "@/utils/formatUrl";
import {PrintableCalendarAspectRatios} from "@/enums/PrintableCalendarAspectRatios";
import {OrientationTypes} from "@/enums/OrientationTypes";
import {delay} from "@/utils/wait-resized-image";
import {EventLocationsMixin} from "@/mixins/EventLocations";
import {DimensionColorTypes} from "@/consts/PrintableCalendarDimensionColor";
import VueDragResize from 'vue-drag-resize';
import {PrintableCalendarWeekdays} from "@/consts/PrintableCalendarWeekdays";
import {CalendarTimeFormatMixin} from "@/mixins/CalendarTimeFormat";
import { CalendarExportMode } from '@/enums/CalendarExportMode';

export default {
  name: "PrintableCalendarMain",
  mixins: [EventLocationsMixin, CalendarTimeFormatMixin],
  components: {
    Loader,
    PrintableCalendarHeader,
    PrintableCalendarToolbar,
    PrintableCalendarPagination,
    PrintableCalendarPdf,
    PrintableCalendarListHeader,
    PrintableCalendarSettings,
    VueHtml2pdf,
    VueDragResize
  },
  data() {
    return {
      isLoadingCalendarPrint: true,
      printCalendarEvents: [],
      printCalendarEventsAll: [],
      allDayEvents: [],
      calendarStartDay: new Date(),
      selectedWingPrintableCalendarName: "All",
      selectedWingsPrintableCalendar: [],
      printCalendarStyle: '',
      printCalendarFormat: '',
      exportQuality: '',
      calendarPrintWeekFilter: [
        CalendarFormatWeek.eventThumbnails,
        CalendarFormatWeek.eventDescription,
        CalendarFormatWeek.location,
      ],
      isDisplayAMPM: true,
      isMeals: true,
      isMealsEventsFinish: false,
      mealsEvents: [],
      paperFormat: "a4",
      headerFont: "",
      headerFontColor: "",
      inputCustomBoxColor: "",
      inputCustomBoxSize: "",
      headerSize: "",
      bodyFont: "",
      bodySize: "",
      locationKeysSize: "",
      locationKeys: "",
      datesBackgroundColor: "",
      datesColor: "",
      selectedWingPrintableCalendar: {},
      isPdfLoading: false,
      isRemoveBorder: false,
      printableCalendarUrl: "",
      printableCalendarColor: "",
      printableCalendarBorderColor: "",
      locations: [],
      calendarDescription: "",
      facilityLogo: "data:image/png;base64,",
      pdfOrientation: "",
      isOpenPreviewPrintCalendarDialog: false,
      printListEventsAll: [],
      printListEvents: [],
      printListEvents2WeeksAll: [],
      printListEvents2Weeks: [],
      pagination: {
        from: 0,
        to: 3,
        current_page: 1,
        per_page: 3,
        total: 0,
        pages: 1
      },
      pagination2Weeks: {
        from: 0,
        to: 3,
        current_page: 1,
        per_page: 3,
        total: 0,
        pages: 1
      },
      printCalendarScreens: [],
      printCalendarMaxEvents: 0,
      printCalendarMaxEvents2Weeks: 0,
      today: null,
      focus: '',
      isDatePositionRight: true,
      disableNavArrowsButtons: false,
      eventsThumbnails: [],
      isCanExport: true,
      is2WeeksSelected: false,
      isDimensionColorEnabled: false,
      isUseWingsCustomNameEnabled: false,
      wingsCustomNameDescription: "",
      selectedFacilityWing: [],
      isCompactMode: false,
      selectedDimensionColorType: '',
      weekdays: [],
      printableCalendarCustomImage: '',
      locationsSizeHeader: {
        left: 0,
        top: 0,
        width: 0,
        height: 0
      },
      customTextBoxSizeHeader: {
        left: 0,
        top: 0,
        width: 0,
        height: 0
      },
      isShowEndTime: true,
      logoSize: {
        width: 220,
        height: 130,
        top: 20,
        left: 20
      },
      customPhotoSize: {
        width: 220,
        height: 130,
        top: 20,
        left: 20
      },
      printableCalendarDecorImage: '',
      decorImageSize: {
        height: 200,
        width: 200,
        top: 200,
        left: 20
      },
      isUseFacilityCustomNameEnabled: false,
      facilityCustomName: '',
      isShowConciergeEvents: false,
      printableCalendarImages: [],
      printableCalendarTextBoxes: [],
      htmlToPdfOptions: {
        margin: 0,
        filename: `calendar.pdf`,
        image: {
          type: 'jpeg',
          quality: 1
        },
        html2canvas: {
          scale: 1,
          useCORS: true
        },
        jsPDF: {
          unit: 'in',
          format: this.paperFormat,
          orientation: this.pdfOrientation
        }
      }
    }
  },
  computed: {
    printableCalendarEvents() {
      return this.$store.state.calenderModule.calenderEvents.filter(x => x.isPublished === true);
    },
    isPrintCalendar() {
      return this.printCalendarStyle === this.printCalendarStyles.calendar;
    },
    isPrintList() {
      return this.printCalendarStyle === this.printCalendarStyles.list;
    },
    isDay() {
      return this.printCalendarFormat === this.typeToLabel.day;
    },
    isWeek() {
      return this.printCalendarFormat === this.typeToLabel.week;
    },
    is2Weeks() {
      return this.printCalendarFormat === this.typeToLabel['2weeks'];
    },
    isMonth() {
      return this.printCalendarFormat === this.typeToLabel.month;
    },
    isDescription() {
      return this.calendarPrintWeekFilter?.includes(this.calendarFormatWeek.eventDescription);
    },
    isLocation() {
      return this.calendarPrintWeekFilter?.includes(this.calendarFormatWeek.location);
    },
    isThumbnails() {
      return this.calendarPrintWeekFilter?.includes(this.calendarFormatWeek.eventThumbnails);
    },
    isCalendarMonthLocation() {
      return this.isPrintCalendar && this.isMonth && this.isLocation && this.locations.length;
    },
    isCalendarFilteredByWings() {
      if(this.selectedWingsPrintableCalendar.length) {
        return true;
      }
    },
    eventTypes() {
      return EventsTypes;
    },
    facility() {
      return this.$store.state.facilityModule.selectedFacility;
    },
    isFacilityTimeFormatAMPM() {
      return this.facility.timeFormat === 'hh:mm A';
    },
    locationsWithShortCode() {
      return this.$store.state.eventLocationModule.eventLocations
        .filter(x => x.type !== EventLocations.Wing)
        .filter(x => {
          if(x.shortCode && x.shortCode.length) {
            return x
          }
        })
    },
    locationsKeys() {
      return this.$store.state.eventLocationModule.eventLocations
        .filter(x => x.type !== EventLocations.Wing)
        .filter(x => {
          if(x.key && x.key) {
            return x;
          }
        })
    },
    isLocalhost() {
      return window.location.hostname === 'localhost';
    },
    calendarPrintFilters() {
      return [
        EventsTypes.LifestylePrograms,
        EventsTypes.PremiumServices,
        EventsTypes.Meal
      ]
    },
    printCalendarStyles() {
      return CalendarStyles;
    },
    calendarFormatWeek() {
      return CalendarFormatWeek;
    },
    typeToLabel() {
      return CalendarTypeEnum;
    },
    exportModeToLabel() {
      return CalendarExportMode;
    },
    isFacilityUS() {
      return this.facility.countryIso === "US";
    },
    isPdfLandscape() {
      return this.pdfOrientation === OrientationTypes.Landscape;
    },
    isPdfPortrait() {
      return this.pdfOrientation === OrientationTypes.Portrait;
    },
    printableCalendarDate() {
      return this.$store.state.calenderModule.printableCalendarDate;
    },
    printableCalendarAspectRatios() {
      return PrintableCalendarAspectRatios;
    },
    isTabloid() {
      return this.paperFormat === this.printableCalendarAspectRatios.tabloid;
    },
    isLetter() {
      return this.paperFormat === this.printableCalendarAspectRatios.letter;
    },
    isA3() {
      return this.paperFormat === this.printableCalendarAspectRatios.a3;
    },
    isA4() {
      return this.paperFormat === this.printableCalendarAspectRatios.a4;
    },
    focus2Weeks() {
      const focusDate = this.calendarStartDay || new Date();
      return moment(focusDate).add(1, 'week').format("YYYY-MM-DD");
    },
    startDayFor2Weeks() {
      let focusDate = moment(this.calendarStartDay).startOf('week');

      if(this.selectedWeekdays.name === "Mon-Sun") {
        focusDate = moment(focusDate).add(1, 'day');
      }

      return moment(focusDate).add(1, 'week').format("YYYY-MM-DD");
    },
    lifestyleProgramCategories() {
      return this.$store.state.socialClubModule.lifestyleProgramCategories
    },
    wingsPrintableCalendar() {
      return this.$store.state.eventLocationModule.eventWings;
    },
    isWeekCompact() {
      return (this.isWeek || this.is2Weeks) && this.isCompactMode;
    },
    isDimensionColorTypeBar() {
      return [DimensionColorTypes.textBar, DimensionColorTypes.bar].includes(this.selectedDimensionColorType);
    },
    isDimensionColorTypeText() {
      return [DimensionColorTypes.textBar, DimensionColorTypes.text].includes(this.selectedDimensionColorType);
    },
    selectedFilterParams() {
      let count = 0;

      if (this.isPrintCalendar) {
        count += this.calculateSelectedFilters([
          { isMonth: ['location'] },
          { isWeek: ['eventThumbnails', 'eventDescription', 'location'] },
          { is2Weeks: ['eventThumbnails', 'eventDescription', 'location'] },
          { isDay: ['eventThumbnails', 'eventDescription', 'location'] }
        ]);
        if (this.isFacilityTimeFormatAMPM && this.isDisplayAMPM) {
          count++;
        }
        if (this.isDay && this.isMeals) {
          count++;
        }
        if (this.isShowEndTime) {
          count++;
        }
        if(this.isShowConciergeEvents) {
          count++;
        }
      }

      if (this.isPrintList) {
        count += this.calculateSelectedFilters([
          { isMonth: ['eventDescription', 'location'] },
          { isWeek: ['eventDescription', 'location'] },
          { is2Weeks: ['eventDescription', 'location'] },
          { isDay: ['eventDescription', 'location'] }
        ]);
        if (this.isDay && this.isMeals) {
          count++;
        }
        if(this.isShowConciergeEvents) {
          count++;
        }
      }

      return count;
    },
    columns() {
      const columnCount = Math.ceil(this.locations.length / 7);
      const columns = [];

      for (let i = 0; i < columnCount; i++) {
        columns.push(this.locations.slice(i * 7, (i + 1) * 7));
      }

      return columns;
    },
    selectedWeekdays() {
      return PrintableCalendarWeekdays.find(x => x.value.every((value, index) => value === this.weekdays[index]));
    },
    locationsSizeHeaderComputed() {
      if(this.facility?.printableCalendarLocationsSizeHeader) {
        this.locationsSizeHeader.top = this.facility.printableCalendarLocationsSizeHeader.top;
        this.locationsSizeHeader.left = this.facility.printableCalendarLocationsSizeHeader.left;
        this.locationsSizeHeader.width = this.facility.printableCalendarLocationsSizeHeader.width;
        this.locationsSizeHeader.height = this.facility.printableCalendarLocationsSizeHeader.height;
      } else {
        this.locationsSizeHeader.width = 350;
        this.locationsSizeHeader.height = 150;
        this.locationsSizeHeader.top = 30;

        if(this.isFacilityUS) {
          this.locationsSizeHeader.left = 1160;
        } else {
          this.locationsSizeHeader.left = 1020;
        }
      }

      return this.locationsSizeHeader;
    },
    customTextBoxSizeHeaderComputed() {
      if(this.facility?.printableCalendarCustomTextBoxSizeHeader) {
        this.customTextBoxSizeHeader.top = this.facility.printableCalendarCustomTextBoxSizeHeader.top;
        this.customTextBoxSizeHeader.left = this.facility.printableCalendarCustomTextBoxSizeHeader.left;
        this.customTextBoxSizeHeader.width = this.facility.printableCalendarCustomTextBoxSizeHeader.width;
        this.customTextBoxSizeHeader.height = this.facility.printableCalendarCustomTextBoxSizeHeader.height;
      } else {
        this.customTextBoxSizeHeader.width = 250;
        this.customTextBoxSizeHeader.height = 50;
        this.customTextBoxSizeHeader.top = 30;

        if(this.isFacilityUS) {
          this.customTextBoxSizeHeader.left = -30;
        } else {
          this.customTextBoxSizeHeader.left = -30;
        }
      }

      return this.customTextBoxSizeHeader;
    },
    decorImageSizeComputed() {
      if(this.facility?.printableCalendarDecorImageSize) {
        this.decorImageSize.top = this.facility.printableCalendarDecorImageSize.top;
        this.decorImageSize.left = this.facility.printableCalendarDecorImageSize.left;
        this.decorImageSize.width = this.facility.printableCalendarDecorImageSize.width;
        this.decorImageSize.height = this.facility.printableCalendarDecorImageSize.height;
      } else {
        this.decorImageSize.width = 200;
        this.decorImageSize.height = 200;
        this.decorImageSize.top = 200;
        this.decorImageSize.left = 20;
      }

      return this.decorImageSize;
    },
    logoSizeComputed() {
      if(this.facility?.printableCalendarLogoSize) {
        this.logoSize.width = this.facility.printableCalendarLogoSize.width;
        this.logoSize.height = this.facility.printableCalendarLogoSize.height;
        this.logoSize.left = this.facility.printableCalendarLogoSize.left;
        this.logoSize.top = this.facility.printableCalendarLogoSize.top;
      } else {
        this.logoSize.width = 220;
        this.logoSize.height = 130;
        this.logoSize.top = 20;
        this.logoSize.left = 20;
      }

      return this.logoSize;
    },
    customPhotoSizeComputed() {
      if(this.facility?.printableCalendarCustomImageSize) {
        this.customPhotoSize.width = this.facility.printableCalendarCustomImageSize.width;
        this.customPhotoSize.height = this.facility.printableCalendarCustomImageSize.height;
        this.customPhotoSize.left = this.facility.printableCalendarCustomImageSize.left;
        this.customPhotoSize.top = this.facility.printableCalendarCustomImageSize.top;
      } else {
        this.customPhotoSize.width = 220;
        this.customPhotoSize.height = 130;
        this.customPhotoSize.top = 20;
        this.customPhotoSize.left = 20;
      }

      return this.customPhotoSize;
    }
  },
  async created() {
    this.checkCalendarDate();
    this.checkCalendarStyle();
    this.checkCalendarFormat();
    this.checkExportQuality();
    this.checkHeaderFont();
    this.checkBodyFont();
    this.checkPdfFormat();
    this.getPrintableCalendarBackgroundColor();
    this.getPrintableCalendarBorderColor();

    this.checkPrintableCalendarSettings();

    this.getPrintableCalendarCustomImage();
    this.getPrintableCalendarDecorImage()
    await this.getPrintableCalendarUrlFacility();
  },
  async mounted() {
    this.isLoadingCalendarPrint = true;
    await this.$store.dispatch("getEventLocations");
    await this.getCalendarEvents()
    await this.$store.dispatch("getLifestyleProgramCategories");
    await this.$store.dispatch("getEventWings");
    await this.$store.dispatch("getAdditionalServices");
    this.checkSelectedWing();
    await this.getPrintableCalendarLogo();
    await this.getPrintCalendarEvents(this.printableCalendarEvents);
    this.getLocations();
    this.checkImages();
    this.checkTextBoxes();

    if (this.printCalendarStyle === this.printCalendarStyles.calendar) {
      this.getMaxEventsOnWeek();
      this.addRowsForCalendar();
    } else if (this.printCalendarStyle === this.printCalendarStyles.list) {
      this.getPrintListEvents(this.printableCalendarEvents);
    }

    this.isLoadingCalendarPrint = false;
  },
  methods: {
    checkCalendarStyle() {
      if(localStorage.getItem("calendarStyle")) {
        this.printCalendarStyle = localStorage.getItem("calendarStyle");
      } else {
        this.printCalendarStyle = this.printCalendarStyles.calendar;
      }
    },
    checkCalendarFormat() {
      if(localStorage.getItem("calendarFormat")) {
        this.printCalendarFormat = localStorage.getItem("calendarFormat");
      } else {
        this.printCalendarFormat = this.typeToLabel.month;
      }
    },
    checkExportQuality() {
      if(localStorage.getItem("exportQuality")) {
        this.exportQuality = localStorage.getItem("exportQuality");
      } else {
        this.exportQuality = this.exportModeToLabel.basic;
      }
    },
    checkBodyFont() {
      this.bodyFont = this.facility?.printableCalendarBodyFont || PrintableCalendarFonts.ProximaNovaRegular;
      this.bodySize = this.facility?.printableCalendarBodyFontSize || PrintableCalendarFontSizes.fontSize12;
    },
    checkHeaderFont() {
      this.headerFont = this.facility?.printableCalendarHeaderFont || PrintableCalendarFonts.MrsEavesMedium;
      this.headerFontColor = this.facility?.printableCalendarHeaderFontColor || "#000000";
      this.headerSize = this.facility?.printableCalendarHeaderFontSize || PrintableCalendarFontSizes.fontSize24;
      this.inputCustomBoxColor = this.facility?.printableCalendarInputCustomBoxColor || "#000000";
      this.inputCustomBoxSize = this.facility?.printableCalendarInputCustomBoxSize || PrintableCalendarFontSizes.fontSize12;
      this.calendarDescription = this.facility?.calendarDescription || "";
    },
    checkPdfFormat() {
      if(this.facility.countryIso === "US") {
        if(this.printCalendarFormat === this.typeToLabel.day || this.printCalendarStyle === this.printCalendarStyles.list) {
          this.paperFormat = "letter";
        } else {
          this.paperFormat = "tabloid";
        }
      }
    },
    checkSelectedWing() {
      this.selectedWingsPrintableCalendar = this.wingsPrintableCalendar.reduce((result, wing) => {
        if (Object.prototype.hasOwnProperty.call(this.facility, 'lastWingWithBorder') && this.facility?.lastWingWithBorder !== null && this.facility?.lastWingWithBorder.includes(wing.id) && this.careLevels && this.careLevels.length) {
          const levels = this.careLevels.filter(level => level.wingsIds.includes(wing.id)).map(level => ({ id: level.id, name: level.name }));
          const levelsIds = levels.map(level => level.id);

          result.push({
            id: wing.id,
            name: wing.name,
            careLevelsIds: levelsIds,
            careLevels: levels,
            backgroundImage: wing.backgroundImage,
            color: wing.backgroundImage
          });
        }
        return result;
      }, []);

      this.selectedFacilityWing = this.selectedWingsPrintableCalendar.map(x => x.id) || [];
    },
    checkPrintableCalendarSettings() {
      this.locationKeysSize = this.facility?.printableCalendarLocationKeysFontSize || PrintableCalendarFontSizes.fontSize12;
      this.locationKeys = this.facility?.hasOwnProperty('printableCalendarHideLocationKeys') ? this.facility?.printableCalendarHideLocationKeys : false;
      this.datesBackgroundColor = this.facility?.printableCalendarDatesBackgroundColor || "#ffffff";
      this.datesColor = this.facility?.printableCalendarDatesColor || "#000000";
      this.wingsCustomNameDescription = this.facility?.wingsCustomNameDescription || "";
      this.facilityCustomName = this.facility?.facilityCustomName || "";
      this.weekdays = this.facility?.printableCalendarWeekdays || [0, 1, 2, 3, 4, 5, 6];
      this.isCompactMode = this.facility?.printableCalendarCompactMode || false;
      this.isShowConciergeEvents = this.facility?.printableCalendarConciergeEvents || false;
      this.isShowEndTime = this.facility?.printableCalendarShowEndTime || false;
      this.isDatePositionRight = this.facility?.printableCalendarDatePositionRight || false;
      this.isDisplayAMPM = this.facility?.printableCalendarDisplayAMPM || false;
    },
    checkImages() {
      if(this.facility?.printableCalendarImages && this.facility?.printableCalendarImages?.length) {
        this.printableCalendarImages = this.facility?.printableCalendarImages;
      } else {
        this.printableCalendarImages = [];
      }
    },
    checkTextBoxes() {
      if(this.facility?.printableCalendarTextBoxes && this.facility?.printableCalendarTextBoxes?.length) {
        this.printableCalendarTextBoxes = this.facility?.printableCalendarTextBoxes;
      } else {
        this.printableCalendarTextBoxes = [];
      }
    },
    getPrintableCalendarCustomImage() {
      this.printableCalendarCustomImage = this.facility?.printableCalendarCustomImage || "";
    },
    getPrintableCalendarDecorImage() {
      this.printableCalendarDecorImage = this.facility?.printableCalendarDecorImage || "";
    },
    async changePrintableCalendar() {
      this.isLoadingCalendarPrint = true;
      this.disableNavArrowsButtons = true;

      await this.getCalendarEvents();

      if (this.printCalendarStyle === this.printCalendarStyles.list) {
        this.getPrintListEvents(this.printableCalendarEvents);
      }

      await this.getPrintCalendarEvents(this.printableCalendarEvents);
      this.getLocations();

      if (this.printCalendarStyle === this.printCalendarStyles.calendar) {
        this.getMaxEventsOnWeek();
        this.addRowsForCalendar();
      }
      console.log("changePrintableCalendar FALSE")
      this.isLoadingCalendarPrint = false;
      this.disableNavArrowsButtons = false;
    },
    async getCalendarEvents() {
      const start = moment(this.$refs.calendarScreen.lastStart?.date).subtract(1, 'month').toDate();
      const end = moment(this.$refs.calendarScreen.lastEnd?.date).add(1, 'month').toDate();
      await this.$store.dispatch('getCalenderEvents', { start: start, end: end });
    },
    async getPrintCalendarEvents(data) {
      this.printCalendarEventsAll = [];
      this.allDayEvents = [];

      const filteredEvents = data.filter((dbEvt) => {
        if (([EventsTypes.LifestylePrograms].includes(dbEvt.type) && !dbEvt.allDay) || (this.isShowConciergeEvents && dbEvt.type === EventsTypes.PremiumServices)) {
          return true;
        }

        if (dbEvt.allDay) {
          this.allDayEvents.push({
            id: dbEvt.id,
            name: dbEvt.name,
            allDay: dbEvt.allDay,
            start: moment(dbEvt.start.seconds * 1000).format("YYYY-MM-DD"),
            lifestyleProgramCategoryColor: dbEvt.lifestyleProgramCategoryColor ?? "",
            isPublished: dbEvt.isPublished,
            borderColor: this.getBorderColor(dbEvt.type, dbEvt.invitees[0]),
          });
        }

        return false;
      });

      const promises = [];
      for(let i = 0; i < filteredEvents.length; i++) {
        const event = filteredEvents[i];

        if(!this.eventsThumbnails.find(x => x.url === event.imageUrl)) {
          this.eventsThumbnails.push({
            url: event.imageUrl,
          });

          promises.push(this.generateEventThumbnail(event.imageUrl))
        }
      }

      await Promise.all(promises);

      filteredEvents.map((dbEvt) => {
        this.generatePrintCalendarEvents(dbEvt);
      })

      this.calendarStartDay = this.$refs.calendarScreen?.lastStart?.date;

      this.printCalendarEventsAll = this.printCalendarEventsAll.filter((event) => {
        return [
          EventsTypes.LifestylePrograms,
          EventsTypes.PremiumServices,
          EventsTypes.ConciergeRequest,
          EventsTypes.ScheduledCall,
          EventsTypes.RealtimeCall,
          EventsTypes.Notice,
          EventsTypes.Meal,
        ].includes(event.type) && this.calendarPrintFilters.includes(event.type);
      });

      this.printCalendarEvents = this.printCalendarEventsAll;
      this.filterEventsBySelectedWings(this.selectedWingsPrintableCalendar);
    },
    async generateEventThumbnail(imageUrl) {
      if (window.location.hostname === 'localhost' || !imageUrl || imageUrl.includes("no-image")) {
        this.eventsThumbnails.find(x => x.url === imageUrl).data = imageUrl;
        return true;
      }

      try {
        return await imageToBase64(imageUrl).then((data) => {
          this.eventsThumbnails.find(x => x.url === imageUrl).data = 'data:image/png;base64,' + data;
          return true;
        })
      } catch (error) {
        this.eventsThumbnails.find(x => x.url === imageUrl).data = imageUrl;
        console.error(`Failed to generate thumbnail for ${imageUrl}: ${error}`);
        return false;
      }
    },
    generatePrintCalendarEvents(dbEvt) {
      this.printCalendarEventsAll.push({
        name: dbEvt.type === EventsTypesMinor.RealtimeCall || dbEvt.type === EventsTypesMinor.ScheduledCall ? dbEvt.inviterName + " - " + dbEvt.name : dbEvt.name,
        id: dbEvt.id,
        imageUrl: this.eventsThumbnails.find(x => x.url === dbEvt.imageUrl).data,
        description: dbEvt.description,
        start: this.formatDate(moment(dbEvt.start.seconds * 1000).toDate(), true),
        end: this.formatDate(dbEvt.end ? moment(dbEvt.end.seconds * 1000).toDate() : null, true),
        type: dbEvt.type,
        allDay: dbEvt.allDay,
        location: dbEvt.location,
        wing: dbEvt?.wing ?? '',
        wingsIds: dbEvt?.wingsIds ?? [],
        date: moment(dbEvt.start.seconds * 1000).format("YYYY-MM-DD"),
        lifestyleProgramCategoryColor: dbEvt.lifestyleProgramCategoryColor ?? "",
        isPublished: dbEvt.isPublished,
        borderColor: this.getBorderColor(dbEvt.type, dbEvt.invitees[0]),
      });
    },
    async changePrintableCalendarBackgroundByWing(wing) {
      if(wing && wing.backgroundImage && this.facility?.isHaveDifferentBorderPerWing) {
        if (this.isLocalhost) {
          this.printableCalendarUrl = wing.backgroundImage;
        } else {
          const printableCalendarPhoto = await imageToBase64(wing.backgroundImage);
          this.printableCalendarUrl = "data:image/png;base64," + printableCalendarPhoto;
        }
      } else if(wing && !wing.backgroundImage && this.facility?.isHaveDifferentBorderPerWing) {
        this.printableCalendarUrl = "";
      } else {
        await this.getPrintableCalendarUrlFacility();
      }
    },
    showErrorOnExporting() {
      this.$toast.open({
        type: 'error',
        message: 'The exported file will not contain your changes as they have not been saved'
      });
    },
    async generatePdf() {
      if(!this.isCanExport) {
        this.showErrorOnExporting();
        return false;
      }

      if (this.exportQuality === this.exportModeToLabel.basic) {
        this.htmlToPdfOptions.html2canvas.scale = 1;
      }
      else if (this.exportQuality === this.exportModeToLabel.high) {
        this.htmlToPdfOptions.html2canvas.scale = 4;
      }

      this.htmlToPdfOptions.jsPDF.format = this.paperFormat;
      this.htmlToPdfOptions.jsPDF.orientation = this.pdfOrientation;
      this.isPdfLoading = true;
      this.isLoadingCalendarPrint = true;
      this.isRemoveBorder = true;
      this.checkZoomBrowser();
      this.resetPagination();

      const decorImage = this.printableCalendarDecorImage;
      if(this.printableCalendarDecorImage && this.printableCalendarDecorImage.length) {
        this.printableCalendarDecorImage = await formatUrl(this.printableCalendarDecorImage);
        this.$forceUpdate();
      }

      setTimeout(async () => {
        try {

          for (let i = 0; i < this.pagination.pages; i++) {
            this.nextCalendarPrint(this.pagination)
            let canvas = null;

            if(this.isPrintCalendar) {
              canvas = await html2canvas(document.querySelector('#calendar-screen'));
            } else {
              canvas = await html2canvas(document.querySelector('#list-calendar-screen'));
            }

            const url = canvas.toDataURL();
            this.printCalendarScreens.push({
              date: this.calendarStartDay,
              page: i + 1,
              is2Weeks: false,
              image: url,
            });
          }

          if(this.is2Weeks) {
            for (let i = 0; i < this.pagination2Weeks.pages; i++) {
              this.nextCalendarPrint(this.pagination2Weeks)
              let canvas = null;

              if(this.isPrintCalendar) {
                canvas = await html2canvas(document.querySelector('#calendar-screen-additional'));
              } else {
                canvas = await html2canvas(document.querySelector('#list-calendar-screen-additional'));
              }

              const url = canvas.toDataURL();
              this.printCalendarScreens.push({
                date: moment(this.calendarStartDay).add(1, 'week'),
                page: i + 1,
                is2Weeks: true,
                image: url,
              });
            }
          }

          await this.$refs.html2Pdf.generatePdf();
          this.printCalendarScreens = [];
        } catch (error) {
          console.error(error)
        } finally {
          this.clearPagination();
          this.addRowsForCalendar();
          this.isRemoveBorder = false;
          this.isLoadingCalendarPrint = false;
          this.printableCalendarDecorImage = decorImage;
        }
      }, 200);
    },
    formatDate(a, withTime): string {
      if (!a) return ''

      return withTime
        ? `${a.getFullYear()}-${a.getMonth() +
        1}-${a.getDate()} ${a.getHours()}:${(a.getMinutes() < 10 ? '0' : '') + a.getMinutes()}`
        : `${a.getFullYear()}-${a.getMonth() + 1}-${a.getDate()}`;
    },
    filterPrintEventsByWings(value) {
      return this.printCalendarEventsAll.filter((x) => {
        if((x?.hasOwnProperty('wingsIds') && x.wingsIds.some(id => value.map(wing => wing.id).includes(id))) || (x?.hasOwnProperty('wingsIds') && !x.wingsIds.length) || !x?.hasOwnProperty('wingsIds')) {
          return x;
        }
      });
    },
    filterListEventsByWings(value) {
      return this.printListEventsAll.filter((x) => {
        if((x?.hasOwnProperty('wingsIds') && x.wingsIds.some(id => value.map(wing => wing.id).includes(id))) || (x?.hasOwnProperty('wingsIds') && !x.wingsIds.length) || !x?.hasOwnProperty('wingsIds')) {
          return x;
        }
      });
    },
    changeListRows() {
      const filters = this.calendarPrintWeekFilter;
      const size = parseInt(this.bodySize);
      let perPageMapping = {};

      if(this.facility.countryIso === "US") {
        if(size <= 10) {
          perPageMapping = {
            '11': 64,
            '01': 64,
            '10': 70,
            '00': 70,
            'default': 64,
          }
        }

        if(size > 10 && size <= 15) {
          perPageMapping = {
            '11': 48,
            '01': 48,
            '10': 54,
            '00': 54,
            'default': 48,
          }
        }

        if(size > 15 && size <= 20) {
          perPageMapping = {
            '11': 38,
            '01': 38,
            '10': 42,
            '00': 42,
            'default': 38,
          }
        }

        if(size > 20 && size <= 25) {
          perPageMapping = {
            '11': 28,
            '01': 28,
            '10': 30,
            '00': 30,
            'default': 28,
          }
        }

        if(size > 25 && size <= 30) {
          perPageMapping = {
            '11': 24,
            '01': 24,
            '10': 24,
            '00': 24,
            'default': 24,
          }
        }

        if(size > 30 && size <= 35) {
          perPageMapping = {
            '11': 20,
            '01': 20,
            '10': 20,
            '00': 20,
            'default': 20,
          }
        }

        if(size > 35 && size <= 40) {
          perPageMapping = {
            '11': 22,
            '01': 22,
            '10': 24,
            '00': 24,
            'default': 22,
          }
        }

        if(size > 40 && size <= 45) {
          perPageMapping = {
            '11': 18,
            '01': 18,
            '10': 18,
            '00': 18,
            'default': 18,
          }
        }

        if(size > 45 && size <= 50) {
          perPageMapping = {
            '11': 16,
            '01': 16,
            '10': 16,
            '00': 16,
            'default': 16,
          }
        }
      } else {
        if(size <= 10) {
          perPageMapping = {
            '11': 66,
            '01': 66,
            '10': 72,
            '00': 72,
            'default': 66,
          }
        }

        if(size > 10 && size <= 15) {
          perPageMapping = {
            '11': 50,
            '01': 50,
            '10': 56,
            '00': 56,
            'default': 50,
          }
        }

        if(size > 15 && size <= 20) {
          perPageMapping = {
            '11': 40,
            '01': 40,
            '10': 44,
            '00': 44,
            'default': 40,
          }
        }

        if(size > 20 && size <= 25) {
          perPageMapping = {
            '11': 28,
            '01': 28,
            '10': 30,
            '00': 30,
            'default': 28,
          }
        }

        if(size > 25 && size <= 30) {
          perPageMapping = {
            '11': 24,
            '01': 24,
            '10': 24,
            '00': 24,
            'default': 24,
          }
        }

        if(size > 30 && size <= 35) {
          perPageMapping = {
            '11': 22,
            '01': 22,
            '10': 24,
            '00': 24,
            'default': 22,
          }
        }

        if(size > 35 && size <= 40) {
          perPageMapping = {
            '11': 18,
            '01': 18,
            '10': 20,
            '00': 20,
            'default': 18,
          }
        }

        if(size > 40 && size <= 45) {
          perPageMapping = {
            '11': 16,
            '01': 16,
            '10': 18,
            '00': 18,
            'default': 16,
          }
        }

        if(size > 45 && size <= 50) {
          perPageMapping = {
            '11': 17,
            '01': 17,
            '10': 17,
            '00': 17,
            'default': 17,
          }
        }
      }

      let filterKey = filters.includes(this.calendarFormatWeek.location) ? '1' : '0';
      filterKey += filters.includes(this.calendarFormatWeek.eventDescription) ? '1' : '0';

      let perPage = perPageMapping[filterKey]
        ? perPageMapping[filterKey]
        : perPageMapping['default'];


      if(this.isPrintList && this.isPdfLandscape) {
        perPage = Math.ceil(perPage / 2.7);
      }

      if(this.is2Weeks) {
        this.pagination2Weeks.current_page = 1;
        this.pagination2Weeks.per_page = perPage;
        this.pagination2Weeks.to = perPage;
        this.pagination2Weeks.from = 0;
        this.pagination2Weeks.total = this.printListEvents.length;
        this.pagination2Weeks.pages = Math.ceil(this.pagination2Weeks.total / perPage);
      }

      this.pagination.current_page = 1;
      this.pagination.per_page = perPage;
      this.pagination.to = perPage;
      this.pagination.from = 0;
      this.pagination.total = this.printListEvents.length;
      this.pagination.pages = Math.ceil(this.pagination.total / perPage);
    },
    changeCalendarRows() {
      const format = this.is2Weeks ? this.typeToLabel.week : this.printCalendarFormat;
      const filters = this.calendarPrintWeekFilter;
      const perPageMapping = {
        'day': {
          '111': 10,
          '011': 10,
          '001': 10,
          '101': 10,
          '110': 10,
          '100': 10,
          '010': 10,
          'default': 10,
        },
        'month': 11,
        'week': {
          '111': 3,
          '011': 6,
          '001': 8,
          '101': 4,
          '110': 3,
          '100': 4,
          '010': 6,
          'default': 11,
        }
      };

      let filterKey = filters?.includes(this.calendarFormatWeek.eventThumbnails) ? '1' : '0';
      filterKey += filters?.includes(this.calendarFormatWeek.eventDescription) ? '1' : '0';
      filterKey += filters?.includes(this.calendarFormatWeek.location) ? '1' : '0';

      let perPage = perPageMapping[format] && perPageMapping[format][filterKey]
        ? perPageMapping[format][filterKey]
        : perPageMapping[format] && perPageMapping[format]['default'];

      if(this.isFacilityUS) {
        if(this.isPrintCalendar && (this.isWeek || this.is2Weeks) && this.isPdfPortrait) {
          perPage = Math.ceil(perPage * 2.2);
        }

        if(this.isPrintCalendar && this.isDay && this.isPdfLandscape) {
          perPage = Math.ceil(perPage / 3);
        }
      }

      if((this.isWeek || this.is2Weeks) && this.isCompactMode) {
        perPage = 100;
      }

      this.pagination.current_page = 1;
      this.pagination.pages = 1;
      this.pagination.per_page = perPage;

      if(this.is2Weeks) {
        this.pagination2Weeks.current_page = 1;
        this.pagination2Weeks.pages = 1;
        this.pagination2Weeks.per_page = perPage;
      }

      if (['week', 'day'].includes(format)) {
        this.getMaxEventsOnWeek();
        this.addRowsForCalendar();
      }
    },
    resetPagination() {
      this.pagination.from = 0;
      this.pagination.to = this.pagination.per_page;
    },
    clearPagination() {
      if (this.printCalendarStyle === this.printCalendarStyles.calendar) {
        if (this.printCalendarFormat === this.typeToLabel.day) {
          this.pagination.from = 0;
          this.pagination.to = this.pagination.per_page;
        } else if ([this.typeToLabel.week, this.typeToLabel["2weeks"]].includes(this.printCalendarFormat)) {
          this.pagination.from = 0;
          this.pagination.to = this.pagination.per_page;

          this.pagination2Weeks.from = 0;
          this.pagination2Weeks.to = this.pagination2Weeks.per_page;
        }
      } else if (this.printCalendarStyle === this.printCalendarStyles.list) {
        this.pagination.from = 0;
        this.pagination.to = this.pagination.per_page;

        this.pagination2Weeks.from = 0;
        this.pagination2Weeks.to = this.pagination2Weeks.per_page;
      }
    },
    getPrintListEvents(data) {
      setTimeout(() => {
        const startDayCalendar = this.$refs.calendarScreen.lastStart?.date;
        const endDayCalendar = this.$refs.calendarScreen.lastEnd?.date;
        const is2Weeks = this.is2Weeks;
        const startDay2Weeks = moment(this.startDayFor2Weeks).format("YYYY-MM-DD");
        const endDay2Weeks = moment(this.startDayFor2Weeks).add(6, 'days').endOf('day').format("YYYY-MM-DD");

        const publishedEvents = data;

        // Process events for the calendar screen
        const dates = [];
        const startCalendar = moment(startDayCalendar).format("YYYY-MM-DD");
        const endCalendar = moment(endDayCalendar).format("YYYY-MM-DD");
        this.calendarStartDay = startDayCalendar;
        this.printListEventsAll = [];
        this.processEvents(publishedEvents, this.printListEventsAll, dates, startCalendar, endCalendar);

        this.printListEvents = this.printListEventsAll;
        this.pagination.current_page = 1;
        this.pagination.from = 0;
        this.pagination.to = this.pagination.per_page;
        this.pagination.total = this.printListEvents.length;
        this.pagination.pages = Math.ceil(this.pagination.total / this.pagination.per_page);

        // Process events for the 2-week view
        if (is2Weeks) {
          const dates2Weeks = [];
          this.printListEvents2WeeksAll = [];
          this.processEvents(publishedEvents, this.printListEvents2WeeksAll, dates2Weeks, startDay2Weeks, endDay2Weeks);

          this.printListEvents2Weeks = this.printListEvents2WeeksAll;
          this.pagination2Weeks.current_page = 1;
          this.pagination2Weeks.from = 0;
          this.pagination2Weeks.to = this.pagination.per_page;
          this.pagination2Weeks.total = this.printListEvents2Weeks.length;
          this.pagination2Weeks.pages = Math.ceil(this.pagination2Weeks.total / this.pagination.per_page);
        }

        this.filterEventsBySelectedWings(this.selectedWingsPrintableCalendar);
      }, 200);
    },
    processEvents(events, targetList, targetDates, startDate, endDate) {
      for (const event of events) {
        const eventDate = moment(event.start.seconds * 1000).format("YYYY-MM-DD");

        if (eventDate >= startDate && eventDate <= endDate &&
          ([EventsTypes.LifestylePrograms].includes(event.type) || (this.isMeals && this.isDay && event.type === EventsTypes.Meal) || (this.isShowConciergeEvents && event.type === EventsTypes.PremiumServices))) {
          const eventData = {
            name: event.type === EventsTypesMinor.RealtimeCall || event.type === EventsTypesMinor.ScheduledCall ?
              `${event.inviterName} - ${event.name}` : event.name,
            id: event.id,
            imageUrl: event.imageUrl,
            description: event.description,
            start: this.formatDate(moment(event.start.seconds * 1000).toDate(), true),
            end: this.formatDate(event.end ? moment(event.end.seconds * 1000).toDate() : null, true),
            type: event.type,
            location: event.location,
            wing: event?.wing ?? '',
            wingsIds: event?.wingsIds ?? [],
            date: moment(event.start.seconds * 1000).format("YYYY-MM-DD"),
            isFirst: !targetDates.includes(eventDate),
            allDay: event.allDay ?? false,
            borderColor: this.getBorderColor(event.type, event.invitees[0]),
          };

          targetList.push(eventData);

          if (!targetDates.includes(eventDate)) {
            targetDates.push(eventDate);
          }
        }
      }
    },
    getLocations() {
      setTimeout(() => {
        const calendarRef = this.$refs.calendarScreen;
        const start = moment(calendarRef.lastStart?.date).subtract(calendarRef.lastStart?.weekday, 'days').format("YYYY-MM-DD");
        const end = moment(calendarRef.lastEnd.date).add(calendarRef.lastEnd.weekday, 'days').format("YYYY-MM-DD");

        const locations = this.printCalendarEvents.reduce((total, current) => {
          const date = moment(current.start).format("YYYY-MM-DD");

          if (!total.includes(current.location) && current.location && date >= start && date <= end) {
            total.push(current.location)
          }

          return total;
        }, []);

        const sortedNames = locations
          .map(name => {
            const foundLocation = this.locationsWithShortCode.find(x => x.name.trimEnd() === name.trimEnd());
            const foundLocationKey = this.locationsKeys.find(x => x.name.trimEnd() === name.trimEnd());
            const key = foundLocationKey?.key || foundLocation?.shortCode || name.slice(0, 2).toUpperCase();
            return { name, key };
          })
          .sort((a, b) => a.key.localeCompare(b.key))
          .map(item => item.name);

        this.locations = sortedNames;
      }, 100)
    },
    async getPrintableCalendarUrlFacility() {
      if (this.facility.printableCalendarUrl) {
        if (this.isLocalhost) {
          this.printableCalendarUrl = this.facility.printableCalendarUrl;
        } else {
          const printableCalendarPhoto = await imageToBase64(this.facility.printableCalendarUrl);
          this.printableCalendarUrl = "data:image/png;base64," + printableCalendarPhoto;
        }
      }
    },
    getPrintableCalendarBackgroundColor() {
      if (this.facility?.printableCalendarColor) {
        this.printableCalendarColor = this.facility?.printableCalendarColor;
      }
    },
    getPrintableCalendarBorderColor() {
      this.printableCalendarBorderColor = this.facility?.printableCalendarBorderColor ?? '#3f51b5';
    },
    async getPrintableCalendarLogo() {
      if (this.isLocalhost) {
        this.facilityLogo = this.facility.printableCalendarLogoUrl || this.facility.staffHubLogoUrl;
      } else {
        const logo = await imageToBase64(this.facility.printableCalendarLogoUrl || this.facility.staffHubLogoUrl);
        this.facilityLogo = this.facilityLogo + logo;
      }
    },
    processWeek(pagination, refsCalendarScreen) {
      const start = moment(refsCalendarScreen.lastStart?.date).toDate();
      const end = moment(refsCalendarScreen.lastEnd?.date).toDate();
      const week = {};

      this.printCalendarEvents.forEach((item) => {
        const date = moment(item.date).toDate();
        if (date >= start && date <= end) {
          if (!week[item.date]) {
            week[item.date] = 1;
          } else {
            week[item.date] += 1;
          }
        }
      });

      pagination.current_page = 1;
      pagination.from = 0;
      pagination.to = pagination.per_page;
      pagination.total = Math.max.apply(null, Object.values(week));
      pagination.pages = Math.ceil(pagination.total / pagination.per_page);
    },
    getMaxEventsOnWeek() {
      delay(200).then(() => {
        if (this.printCalendarFormat === this.typeToLabel.day) {
          const start = moment(this.$refs.calendarScreen.lastStart?.date).startOf('day').toDate();
          const end = moment(this.$refs.calendarScreen.lastEnd?.date).endOf('day').toDate();
          const day = {};

          this.printCalendarEvents.forEach((item) => {
            const date = moment(item.date).toDate()
            if (date >= start && date <= end) {
              if (!day[item.date]) {
                day[item.date] = 1
              } else {
                day[item.date] += 1;
              }
            }
          });

          this.pagination.current_page = 1;
          this.pagination.from = 0;
          this.pagination.to = this.pagination.per_page;
          this.pagination.total = Math.max.apply(null, Object.values(day));
          this.pagination.pages = Math.ceil(this.pagination.total / this.pagination.per_page);
        }

        if ([this.typeToLabel.week, this.typeToLabel["2weeks"]].includes(this.printCalendarFormat)) {
          const start = moment(this.$refs.calendarScreen.lastStart?.date).toDate();
          const end = moment(this.$refs.calendarScreen.lastEnd?.date).toDate();
          const week = {};

          this.printCalendarEvents.forEach((item) => {
            const date = moment(item.date).toDate()
            if (date >= start && date <= end) {
              if (!week[item.date]) {
                week[item.date] = 1
              } else {
                week[item.date] += 1;
              }
            }
          });

          this.pagination.current_page = 1;
          this.pagination.from = 0;
          this.pagination.to = this.pagination.per_page;
          this.pagination.total = Math.max.apply(null, Object.values(week));
          this.pagination.pages = Math.ceil(this.pagination.total / this.pagination.per_page);
          this.processWeek(this.pagination, this.$refs.calendarScreen);
        }

        if (this.printCalendarFormat === this.typeToLabel['2weeks']) {
          this.processWeek(this.pagination2Weeks, this.$refs.calendarScreenAdditional);
        }
      })
    },
    checkZoomBrowser() {
      const scale = window.devicePixelRatio;
      console.log(`Маштаб ${scale}`)

      if(scale !== 1 && scale !== 2) {
        this.$toast.open({
          message: this.$t("PrintableCalendar.ErrorZoom"),
          type: "error"
        });

        return false;
      }
    },
    closePreviewPrintCalendarDialog() {
      this.isOpenPreviewPrintCalendarDialog = false;
      this.printCalendarScreens = [];
    },
    checkFormatCalendar() {
      if (this.printCalendarFormat === this.typeToLabel.day) {
        this.pdfOrientation = "portrait";
      } else {
        this.pdfOrientation = "landscape";
        this.setPagination(this.pagination);
        this.setPagination(this.pagination2Weeks);
        this.addRowsForCalendar();
      }

      if (this.printCalendarStyle === this.printCalendarStyles.list) {
        this.pdfOrientation = "portrait";
        this.setPagination(this.pagination);
        this.setPagination(this.pagination2Weeks);
      }
    },
    setPagination(pagination) {
      pagination.current_page = 1;
      pagination.from = 0;
      pagination.to = pagination.per_page;
    },
    addRowsForCalendar() {
      this.printCalendarMaxEvents = 0;
      this.printCalendarMaxEvents2Weeks = 0;

      if (this.printCalendarStyle === this.printCalendarStyles.calendar) {
        delay(200).then(() => {
          this.printCalendarMaxEvents = this.generateRowsForCalendar(this.$refs.calendarScreen, this.pagination);

          if (this.is2Weeks) {
            this.printCalendarMaxEvents2Weeks = this.generateRowsForCalendar(this.$refs.calendarScreenAdditional, this.pagination2Weeks);
          }
        });
      }
    },
    generateRowsForCalendar(refsCalendarScreen, pagination) {
      const days = [];
      const dateStart = moment(refsCalendarScreen.lastStart?.date);
      const dateEnd = moment(refsCalendarScreen.lastEnd?.date);
      const week = {};

      while (dateEnd.diff(dateStart, 'days') >= 0) {
        days.push(dateStart.format('YYYY-MM-DD'));
        dateStart.add(1, 'days');
      }

      days.forEach((item) => {
        const count = this.printCalendarEvents
          .filter((x) => x.date === item)
          .slice(pagination.from, pagination.to).length;
        week[item] = count;
      });

      return Math.max.apply(null, Object.values(week));
    },
    inputCalendarPrint(type: string) {
      const pagination = type === 'default' ? this.pagination : this.pagination2Weeks;
      const result = ((pagination.current_page - 1) * pagination.per_page);

      pagination.from = result;
      pagination.to = result + pagination.per_page;

      this.addRowsForCalendar();
    },
    nextCalendarPrint(pagination) {
      pagination.from += pagination.per_page;
      pagination.to += pagination.per_page;
      this.addRowsForCalendar();
    },
    routeToEndpoint() {
      const env = getRegionEnv();
      const start = this.$refs.calendarScreen.lastStart?.date;
      const end = this.$refs.calendarScreen.lastEnd?.date;
      const wing = this.selectedWingPrintableCalendarName;
      const link = `${env}/externalClientsApi/calendar/feed/${this.facility.id}?start_date=${start}&end_date=${end}${wing.length && wing !== 'All' ? '&wing=' + wing : ''}`;
      window.open(link, '_blank').focus();
    },
    monthDayFormat(day) {
      return moment(day.date).format('dddd')
    },
    weeklyCalendarEvents(date) {
      if (this.printCalendarFormat === this.typeToLabel.day) {
        const arr = this.printCalendarEvents.filter(x => x.date === date).sort((a, b) => moment(a.start).diff(moment(b.start))).slice(this.pagination.from, this.pagination.to);
        const sum = this.printCalendarMaxEvents - arr.length;
        this.printCalendarMaxEvents = 0;

        if (sum > 0) {
          for (let i = 0; i < sum; i++) {
            arr.push({})
          }
        }

        if(this.isMeals) {
          if(!this.isMealsEventsFinish || !this.mealsEvents.length) {
            this.pushMealsEvents(date);
          }
        } else {
          if(this.isMealsEventsFinish || this.mealsEvents.length) {
            this.isMealsEventsFinish = false;
            this.mealsEvents = [];
          }
        }

        return [...arr, ...this.mealsEvents].sort((a, b) => moment(a.start).diff(moment(b.start)));
      }

      if([this.typeToLabel.week, this.typeToLabel['2weeks']].includes(this.printCalendarFormat)) {
        const arr = this.printCalendarEvents.filter(x => x.date === date).sort((a, b) => moment(a.start).diff(moment(b.start))).slice(this.pagination.from, this.pagination.to);
        const sum = this.printCalendarMaxEvents - arr.length;

        if (sum > 0) {
          for (let i = 0; i < sum; i++) {
            arr.push({})
          }
        }

        return arr;
      }
    },
    weeklyCalendarEvents2Weeks(date) {
      if(this.printCalendarFormat === this.typeToLabel['2weeks']) {
        const arr = this.printCalendarEvents.filter(x => x.date === date).sort((a, b) => moment(a.start).diff(moment(b.start))).slice(this.pagination2Weeks.from, this.pagination2Weeks.to);
        const sum = this.printCalendarMaxEvents2Weeks - arr.length;

        if (sum > 0) {
          for (let i = 0; i < sum; i++) {
            arr.push({})
          }
        }

        return arr;
      }
    },
    async pushMealsEvents(date) {
      if(!this.mealsEvents.length && !this.isMealsEventsFinish) {
        this.isMealsEventsFinish = true;

        const events = this.printableCalendarEvents
          .filter(x => x.type === this.eventTypes.Meal)
          .filter(x => moment(x.start.seconds * 1000).format("YYYY-MM-DD") === moment(date).format("YYYY-MM-DD"))

        for(let i = 0; i < events.length; i++) {
          const dbEvt = events[i];
          const image = await formatUrl(dbEvt.imageUrl);

          this.mealsEvents.push({
            name: dbEvt.type === EventsTypesMinor.RealtimeCall || dbEvt.type === EventsTypesMinor.ScheduledCall ? dbEvt.inviterName + " - " + dbEvt.name : dbEvt.name,
            id: dbEvt.id,
            imageUrl: image,
            description: dbEvt.description,
            start: this.formatDate(moment(dbEvt.start.seconds * 1000).toDate(), true),
            end: this.formatDate(dbEvt.end ? moment(dbEvt.end.seconds * 1000).toDate() : null, true),
            type: dbEvt.type,
            allDay: dbEvt.allDay,
            location: dbEvt.location,
            wing: dbEvt?.wing ?? '',
            date: moment(dbEvt.start.seconds * 1000).format("YYYY-MM-DD"),
            lifestyleProgramCategoryColor: dbEvt.lifestyleProgramCategoryColor ?? "",
            isPublished: dbEvt.isPublished
          });
        }
      }
    },
    timeFormatEvent(time) {
      if(this.isFacilityTimeFormatAMPM) {
        if(this.isDisplayAMPM) {
          return moment(time).format('LT')
        } else {
          return moment(time).format('h:mm')
        }
      }

      return moment(time).format('HH:mm')
    },
    setCalendarDescription(value) {
      this.calendarDescription = value;
    },
    setWingsCustomNameDescription(value) {
      this.wingsCustomNameDescription = value;
    },
    setFacilityCustomName(value) {
      this.facilityCustomName = value;
    },
    changeFacilityCustomName(value) {
      this.isUseFacilityCustomNameEnabled = value;
    },
    uppercase (value) {
      if (!value) return '';

      const foundLocationKey = this.locationsKeys.find(x => x.name.trimEnd() === value.trimEnd());
      if (foundLocationKey) {
        return foundLocationKey.key;
      }

      const foundLocation = this.locationsWithShortCode.find(x => x.name.trimEnd() === value.trimEnd());
      if (foundLocation) {
        return foundLocation.shortCode;
      }

      value = value.toString()
      return value.slice(0, 2).toUpperCase()
    },
    closePrintableCalendar() {
      this.$router.push("/calendar")
    },
    eventsForDay(date) {
      return this.printCalendarEvents.filter(x => x.date === date).sort((a, b) => moment(a.start).diff(moment(b.start)))
    },
    prev() {
      this.$emit('prev')
      this.$refs.calendarScreen.prev();

      setTimeout(() => {
        this.changeDateCalendar();
      }, 100);
    },
    next() {
      this.$emit('next')
      this.$refs.calendarScreen.next();

      setTimeout(() => {
        this.changeDateCalendar();
      }, 100);
    },
    changeDateCalendar() {
      this.calendarStartDay = this.$refs.calendarScreen?.lastStart?.date;
      this.$store.commit("setPrintableCalendarDate", this.calendarStartDay);
      this.changePrintableCalendar()
    },
    checkCalendarDate() {
      if(this.printableCalendarDate) {
        this.focus = this.printableCalendarDate;
      }
    },
    changeBackgroundImage(src: string) {
      this.printableCalendarUrl = src;
    },
    changeBackgroundColor(color: string) {
      this.printableCalendarColor = color;
    },
    changeBorderColor(color: string) {
      this.printableCalendarBorderColor = color;
    },
    changeHeaderFontColor(color) {
      this.headerFontColor = color;
    },
    changeInputCustomBoxColor(color) {
      this.inputCustomBoxColor = color;
    },
    changeInputCustomBoxSize(font: string) {
      this.inputCustomBoxSize = font;
    },
    changeHeaderFonts(font: string) {
      this.headerFont = font;
    },
    changeHeaderFontsSize(font: string) {
      this.headerSize = font;
    },
    changeBodyFonts(font: string) {
      this.bodyFont = font;
    },
    changeBodyFontsSize(font: string) {
      this.bodySize = font;

      if (this.printCalendarStyle === this.printCalendarStyles.calendar) {
        this.changeCalendarRows();
        this.clearPagination();
      } else {
        this.getPrintListEvents(this.printableCalendarEvents);
        this.changeListRows();
      }
      this.checkPdfFormat();
    },
    changeLocationKeysFontSize(font: string) {
      this.locationKeysSize = font;
    },
    changeLocationKeys(value: boolean) {
      this.locationKeys = value;
    },
    changeDatesBackgroundColor(color: string) {
      this.datesBackgroundColor = color;
    },
    changeDatesColor(color: string) {
      this.datesColor = color;
    },
    addAbilityToExport() {
      this.isCanExport = true;
    },
    removeAbilityToExport() {
     this.isCanExport = false;
    },
    set2WeeksFormat(value) {
      this.is2WeeksSelected = value;
    },
    getBorderColor(type: string, programId: string) {
      if(type === EventsTypes.LifestylePrograms) {
        const program = this.$store.state.socialClubModule.socialClubs.find(x => x.id === programId);

        return (program && program.lifestyleProgramCategoryId)
          ? this.lifestyleProgramCategories.find(x => x.id === program.lifestyleProgramCategoryId)?.color || ""
          : "";
      }

      if(type === EventsTypes.PremiumServices) {
        const service = this.$store.state.additionalServicesModule.additionalServices.find(x => x.id === programId);

        return (service && service.categoryId)
          ? this.lifestyleProgramCategories.find(x => x.id === service.categoryId)?.color || ""
          : "";
      }
    },
    changeDisplayDimensionColor(value) {
      this.isDimensionColorEnabled = value;
    },
    changeDisplayWingsCustomName(value) {
      this.isUseWingsCustomNameEnabled = value;
    },
    changeDimensionColorType(value) {
      this.selectedDimensionColorType = value
    },
    filterEventsBySelectedWings(value) {
      if (this.printCalendarStyle === this.printCalendarStyles.calendar) {
        this.isLoadingCalendarPrint = true;

        if(value.length === this.wingsPrintableCalendar.length || !value.length) {
          this.getPrintableCalendarUrlFacility();
          this.printCalendarEvents = this.printCalendarEventsAll;
        } else {
          this.changePrintableCalendarBackgroundByWing(value.filter(x => x.backgroundImage)[value?.length - 1]);
          this.printCalendarEvents = this.filterPrintEventsByWings(value);
        }

        this.clearPagination();

        setTimeout(() => {
          this.changeCalendarRows();
          this.isLoadingCalendarPrint = false;
        }, 200);
      } else {
        if(value === this.wingsPrintableCalendar.length || !value.length) {
          this.getPrintableCalendarUrlFacility();
          this.printListEvents = this.printListEventsAll;
        } else {
          this.changePrintableCalendarBackgroundByWing(value.filter(x => x.backgroundImage)[value?.length - 1]);
          this.printListEvents = this.filterListEventsByWings(value);
        }
      }
    },
    isShowDate(currentEvent, prevEvent) {
      const currentEventDate = currentEvent && moment(currentEvent.date);
      const prevEventDate = prevEvent && moment(prevEvent.date);

      return !prevEventDate || (currentEventDate && prevEventDate && currentEventDate.isAfter(prevEventDate));
    },
    calculateSelectedFilters(filters) {
      let count = 0;
      for (const filterSet of filters) {
        for (const filter in filterSet) {
          if (this[filter]) {
            filterSet[filter].forEach(param => {
              if (this.calendarPrintWeekFilter.includes(this.calendarFormatWeek[param])) {
                count++;
              }
            });
          }
        }
      }
      return count;
    },
    changeCustomImage(value: string) {
      this.printableCalendarCustomImage = value;
    },
    changeDecorImage(value: string) {
      this.printableCalendarDecorImage = value;
    },
    changeImage(value) {
      this.printableCalendarImages[value.index].url = value.url;
      this.printableCalendarImages[value.index].position.height = value.height;
      setTimeout(() => {
        this.printableCalendarImages[value.index].position.width = value.width;
      }, 100)
    },
    removeImage(index) {
      const arr = this.printableCalendarImages.filter((item, i) => i !== index);
      this.printableCalendarImages = []

      this.$nextTick(() => {
        this.printableCalendarImages = arr;
      })
    },
    addNewImage() {
      this.printableCalendarImages.push({
        url: this.facilityLogo,
        page: 'all',
        week: 'all',
        position: {
          height: 120,
          width: 240,
          top: 20,
          left: this.isFacilityUS ? 1200 : 1070
        }
      })
    },
    addNewTextBox() {
      this.printableCalendarTextBoxes.push({
        content: "Textbox",
        page: 'all',
        week: 'all',
        font: PrintableCalendarFonts.ProximaNovaRegular,
        fontSize: "14px",
        color: "#000000",
        position: {
          height: 50,
          width: 200,
          top: 45,
          left: this.isFacilityUS ? 1250 : 1100
        }
      })
    },
    calculateLocationsX() {
      const xMultiplier = this.isFacilityUS ? (this.isLetter ? 0.9 : 1) : (this.isA3 ? 1 : 1);
      return this.isLoadingCalendarPrint ? (this.locationsSizeHeaderComputed.left * xMultiplier) : this.locationsSizeHeaderComputed.left;
    },
    async hasDownloaded({ html2pdf, options, pdfContent }) {
      this.isPdfLoading = false;
    }
  },
  watch: {
    selectedWingsPrintableCalendar(value) {
      this.filterEventsBySelectedWings(value);
      this.getLocations()
    },
    async printCalendarFormat(value) {
      localStorage.setItem('calendarFormat', value);

      if (this.printCalendarStyle === this.printCalendarStyles.calendar) {
        this.changeCalendarRows();
        this.clearPagination();
      } else {
        this.getPrintListEvents(this.printableCalendarEvents);
      }
      this.checkPdfFormat();
      this.checkFormatCalendar();

      this.$nextTick(() => {
        this.calendarStartDay = this.$refs.calendarScreen.lastStart?.date;

        if(this.datesBackgroundColor) {
          const weekdayHeaders = document.querySelectorAll('.v-calendar-weekly__head');
          weekdayHeaders.forEach((header: any) => {
            header.style.backgroundColor = this.datesBackgroundColor;
          });
        }

        if(this.datesColor) {
          const weekdayHeaders = document.querySelectorAll('.v-calendar-weekly__head');
          weekdayHeaders.forEach((header: any) => {
            header.style.color = this.datesColor;
          });
        }

        if(this.isCompactMode && (this.isWeek || this.is2Weeks)) {
          this.isShowEndTime = false;
          const filterParams = [this.calendarFormatWeek.eventThumbnails, this.calendarFormatWeek.eventDescription];
          this.calendarPrintWeekFilter = this.calendarPrintWeekFilter.filter(x => !filterParams.includes(x));
        }
      })
    },
    printCalendarStyle(value) {
      localStorage.setItem('calendarStyle', value);

      if (value === this.printCalendarStyles.calendar) {
        this.calendarPrintWeekFilter = [
          this.calendarFormatWeek.eventThumbnails,
          this.calendarFormatWeek.eventDescription,
          this.calendarFormatWeek.location,
        ];
        setTimeout(() => {
          this.changeCalendarRows();
          this.clearPagination();
        }, 100)
      } else {
        this.calendarPrintWeekFilter = [
          this.calendarFormatWeek.eventDescription,
          this.calendarFormatWeek.location,
        ];
        setTimeout(() => {
          this.getPrintListEvents(this.printableCalendarEvents);
        }, 100)
      }

      this.checkFormatCalendar()
      this.checkPdfFormat();
    },
    calendarPrintWeekFilter() {
      if (this.isPrintCalendar) {
        this.changeCalendarRows();
      } else {
        this.changeListRows();
      }
    },
    isCompactMode(value) {
      if(value) {
        const filterParams = [this.calendarFormatWeek.eventThumbnails, this.calendarFormatWeek.eventDescription];
        this.calendarPrintWeekFilter = this.calendarPrintWeekFilter.filter(x => !filterParams.includes(x));

        if (!this.calendarPrintWeekFilter.includes(this.calendarFormatWeek.location)) {
          this.calendarPrintWeekFilter.push(this.calendarFormatWeek.location);
        }

        if(this.isPrintCalendar && (this.isWeek || this.is2Weeks)) {
          this.isShowEndTime = false;
        }
      }

      if (this.isPrintCalendar) {
        this.changeCalendarRows();
      } else {
        this.changeListRows();
      }
    },
    isMeals() {
      if (this.printCalendarStyle === this.printCalendarStyles.list) {
        this.getPrintListEvents(this.printableCalendarEvents);
      }
    },
    isShowConciergeEvents() {
      if (this.printCalendarStyle === this.printCalendarStyles.list) {
        this.getPrintListEvents(this.printableCalendarEvents);
      }

      if(this.printCalendarStyle === this.printCalendarStyles.calendar) {
        this.getPrintCalendarEvents(this.printableCalendarEvents);
      }
    },
    paperFormat(value) {
      if(this.isFacilityUS) {
        const isLetterAspectRatio = value === this.printableCalendarAspectRatios.letter;

        if((this.isPrintCalendar && this.isDay && isLetterAspectRatio) || (this.isPrintList)) {
          this.pdfOrientation = "portrait";
        } else {
          this.pdfOrientation = "landscape";
        }

        if(this.isPrintCalendar) {
          this.changeCalendarRows();
        } else {
          this.changeListRows();
        }
      }
    },
    weekdays() {
      if(this.isPrintList && (this.isWeek || this.is2Weeks)) {
        this.getPrintListEvents(this.printableCalendarEvents);
      }

      this.$nextTick(() => {
        this.calendarStartDay = this.$refs.calendarScreen.lastStart?.date;
      })
    },
    datesBackgroundColor(value) {
      if(value) {
        const weekdayHeaders = document.querySelectorAll('.v-calendar-weekly__head');
        weekdayHeaders.forEach((header: any) => {
          header.style.backgroundColor = value;
        });
      }
    },
    datesColor(value) {
      if(value) {
        const weekdayHeaders = document.querySelectorAll('.v-calendar-weekly__head');
        weekdayHeaders.forEach((header: any) => {
          header.style.color = value;
        });
      }
    },
    exportQuality(value) {
      localStorage.setItem('exportQuality', value)
    }
  }
}
